import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["fieldKey", "fields", "flushOnTop", "module"];
import styled from 'foundations-theming/utils';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import FieldKeyLabel from 'ContentComponents/components/cmv2/FieldKeyLabel';
import HelpTooltip from 'ContentComponents/components/cmv2/HelpTooltip';
import SanitizedLabel from 'ContentComponents/components/cmv2/SanitizedLabel';
import * as FieldTypes from 'ContentUtils/constants/CustomWidgetFieldTypes';
import { makeSpacedComponent } from 'ContentComponents/components/cmv2/components/SpacedComponent';
import { getFieldFromKey } from 'ContentComponents/components/cmv2/utils';
import FieldLabelIcon from './FieldLabelIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HeaderContainer = styled.div.withConfig({
  displayName: "EditFormHeader__HeaderContainer"
})(({
  isGroup,
  theme
}) => {
  return isGroup ? `
  border-bottom: ${theme.borderWidth['100']} solid ${theme.color['border-core-subtle']};

  & + div [data-is-group]:first-child {
    border-top: none
}
  ` : '';
});
const SpacedH4 = makeSpacedComponent('h4');
const SpacedH5 = makeSpacedComponent('h5');
const EditFormHeader = props => {
  const {
      fieldKey,
      fields,
      flushOnTop,
      module
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const field = getFieldFromKey(fields, fieldKey) || {};
  const {
    type: fieldType,
    help_text: helpText,
    inline_help_text: inlineHelpText,
    icon
  } = field;
  const isGroup = Boolean(fieldType === FieldTypes.GROUP);
  const showInlineHelpText = isGroup && inlineHelpText; // otherwise the inline help text is rendered inside an alert in EditForm component
  let {
    label
  } = props;
  if (fieldKey) {
    label = /*#__PURE__*/_jsx(FieldKeyLabel, Object.assign({}, rest, {
      fieldKey: fieldKey,
      fields: fields,
      module: module
    }));
  }
  if (!label) {
    return null;
  }
  const SpacedHeader = isGroup ? SpacedH4 : SpacedH5;
  return /*#__PURE__*/_jsxs(HeaderContainer, {
    isGroup: isGroup,
    children: [/*#__PURE__*/_jsx(SpacedHeader, {
      marginBlockEnd: showInlineHelpText ? '200' : '500',
      marginBlockStart: !flushOnTop ? '400' : undefined,
      paddingInline: "600",
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        children: [icon && icon.name && /*#__PURE__*/_jsx(FieldLabelIcon, {
          icon: icon,
          largerIcon: true
        }), /*#__PURE__*/_jsx(TruncateString, {
          useFlex: true,
          fixedChildren: fieldKey && helpText && /*#__PURE__*/_jsx(HelpTooltip, {
            iconProps: {
              marginInlineStart: '100'
            },
            title: /*#__PURE__*/_jsx(SanitizedLabel, {
              label: helpText
            })
          }),
          children: label
        })]
      })
    }), showInlineHelpText && /*#__PURE__*/_jsx(Text, {
      as: "small",
      display: "inline-block",
      marginBlockStart: "100",
      marginBlockEnd: "500",
      paddingInline: "600",
      use: "help",
      children: /*#__PURE__*/_jsx("strong", {
        children: /*#__PURE__*/_jsx(SanitizedLabel, {
          label: inlineHelpText,
          useStrict: true
        })
      })
    })]
  });
};
export default EditFormHeader;